var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_1091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 0C10.8372 0 7.43066 3.38689 7.43066 7.54991V24.4872C7.43066 27.527 9.91351 30.0001 12.9533 30.0001C15.9931 30.0001 18.4759 27.527 18.4759 24.4872V9.69291C18.4759 7.77637 16.9167 6.21714 15.0001 6.21714C13.0836 6.21714 11.5244 7.77637 11.5244 9.69291V22.5007C11.5244 23.1406 12.0431 23.6593 12.6829 23.6593C13.3228 23.6593 13.8415 23.1406 13.8415 22.5007V9.69291C13.8415 9.05406 14.3612 8.53434 15.0001 8.53434C15.6389 8.53434 16.1587 9.05406 16.1587 9.69291V24.4872C16.1587 26.2493 14.7153 27.6829 12.9532 27.6829C11.1912 27.6829 9.74781 26.2493 9.74781 24.4872V7.54991C9.74781 4.66464 12.1148 2.3172 15.0001 2.3172C17.8855 2.3172 20.2525 4.66458 20.2525 7.54991V23.4026C20.2525 24.0424 20.7712 24.5612 21.411 24.5612C22.0509 24.5612 22.5696 24.0424 22.5696 23.4026V7.54991C22.5696 3.38689 19.1631 0 15.0001 0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_1091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClip);
export default __webpack_public_path__ + "static/media/icon-clip.d2f76013c56ef467210fb949635e15db.svg";
export { ForwardRef as ReactComponent };